import { FetchApiResponse } from "redux/types";

export enum IntegrationLogReportReduxTypes {
    INTEG_LOG_REPORT = "@@auth/INTEG_LOG_REPORT",
    INTEG_LOG_REPORT_SUCCESS = "@@auth/INTEG_LOG_REPORT_SUCCESS",
    INTEG_LOG_REPORT_ERROR = "@@auth/INTEG_LOG_REPORT_ERROR"
}

export type IntegrationLogReportActionDispatch = {
    type: | IntegrationLogReportReduxTypes.INTEG_LOG_REPORT;
    payload: any;
}

export type IntegrationLogReportReducerDispatch = {
    type: | IntegrationLogReportReduxTypes.INTEG_LOG_REPORT
    | IntegrationLogReportReduxTypes.INTEG_LOG_REPORT_SUCCESS
    | IntegrationLogReportReduxTypes.INTEG_LOG_REPORT_ERROR

    payload: {
        data?: FetchApiResponse<IntegrationLogReport>
        error?: string
    }
}

export type IntegrationLogReport = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string;
    createdOn: string;
}

//action type
export type IntegrationLogReportPayload = {
    source : string,
    date : string,
    saveReport: boolean
}

export type IntegrationLogReportSaga = {
    type : string,
    payload: IntegrationLogReportPayload
}

export type IntegrationLogReportReducer = {
    loading ?: boolean
    data ?: {},
    error ?: string | null;
}